module.exports = __webpack_public_path__ + "img/footer-bank-icon.35f54690.svg";